import React from 'react';
import { Snackbar as MuiSnackbar, Alert, Theme, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import { useSnackbar } from '@/common/hooks/useSnackbar';
import EllipsisTextLine from '../Text/EllipsisTextLine';

export const GenericSnackbar: React.FC = () => {
  const { /*isOpen, */snackbarData, handleCloseSnackbar } = useSnackbar();
  const isMediumScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  if (!snackbarData) return null;
  const renderContent = () => {
    // User is listening to a track
    if (snackbarData.user && snackbarData.track) {
      return (
        <>
          {snackbarData.user.email} is listening to:
          <br />
          <strong>
            <EllipsisTextLine
              maxWidth={250}
              textContent={snackbarData.track.name}
            />
          </strong>
        </>
      );
    }

    // Standard message
    return snackbarData.message;
  };

  const renderIcon = () => {
    if (snackbarData.icon) {
      return snackbarData.icon;
    }

    if (snackbarData.user?.avatar) {
      return (
        <Image
          height={40}
          width={40}
          src={snackbarData.user.avatar}
          alt={snackbarData.user.email ?? ''}
        />
      );
    }

    return undefined;
  };

  return (
    <MuiSnackbar
      open={true}
      autoHideDuration={snackbarData.duration}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ marginBottom: isMediumScreen ? 12 : 10, backgroundColor: 'transparent' }}
      onClose={handleCloseSnackbar}
    >
      <Alert
        icon={renderIcon()}
        severity={snackbarData.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {renderContent()}
      </Alert>
    </MuiSnackbar>
  );
};
